import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../models/auth.models';
import { Observable, throwError } from 'rxjs';

import { Notificacion } from '../models/Notificacion';
import { notificaciondocumento } from '../models/NotificacionesDocumentos';
import { catchError, map } from 'rxjs/operators';

import { ConfigService } from '../../ConfigService';
import { reporteinicial } from '../../pages/facturador/Modelos/Modelos/reporteinicial';


@Injectable({ providedIn: 'root' })
export class UserProfileService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`/api/login`);
    }
    getReporteinicial(idcompania:number): Observable<reporteinicial> {
      return this.http.post<reporteinicial>(ConfigService.settings.apiUrl+"Consultas/reporte?idcompania="+idcompania,"");

  }
    getNotificaciones(idcliente:number,idcompania:number): Observable<Notificacion[]> {
      return this.http.post<Notificacion[]>(ConfigService.settings.apiUrl+"Consultas/ConsultaNotificaciones?idcompania="+idcompania+"&idusuario="+idcliente,"");
    }
    getdocumentoalerta(idcliente:number,idcompania:number) {
      return this.http.post<notificaciondocumento>(ConfigService.settings.apiUrl+"Consultas/ConsultaNotificaciones?idcompania="+idcompania+"&idusuario="+idcliente,"")
      .pipe(
        map((data: notificaciondocumento) => {
          return data;
        }), catchError( error => {
          return throwError( 'Something went wrong!' );
        })
      )

    }
    register(user: User) {
        return this.http.post(`/users/register`, user);
    }
    async consultacertificado(idcompania : Number):Promise<number> {
      let respuesta= this.http.post<number>(ConfigService.settings.apiUrl+"Usuarios/certificado?idcompania="+idcompania,"").toPromise()
      return respuesta
  }

}
